import { Box, Typography } from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import { getWeekday } from './constants';

function DateContainer({ cellDate, isToday, children = null }) {
  const { formatMessage } = useLocalization();
  const weekDay = getWeekday({ formatMessage, number: cellDate.day() + 1 });
  const day = cellDate.format('D');

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography
        variant="subtitle2"
        sx={{
          alignSelf: 'flex-start',
          mb: 1,
          ...(isToday ? { fontWeight: 700 } : { fontWeight: 'normal' }),
        }}>
        {weekDay?.shortLabel} {day}
      </Typography>
      {children}
    </Box>
  );
}

export default DateContainer;
